const routes = {

  // Sidebar Home
  '/': 'Home',
  '/home/book-a-tool':'Book a Tool',

  // Sidebar Asset
  '/asset': 'Asset',
  '/assets': 'Assets',
  '/asset/request-asset': 'Request Asset',

  // Sidebar Job
  '/job': 'Jobs',
  '/job/edit-site': 'Add / Edit Site',

  // Sidebar User
  '/user': 'User',
  '/user/request-user': 'Request User',
  '/user/settings': 'User Settings',

  // Sidebar Report
  '/report': 'Reports',
  '/report/request-report': 'Request Report',

  // Sidebar Admin
  '/admin': 'Admin',
  '/admin/all-activities': 'All Activities',
  '/admin/locate-asset':'Locate Asset',
  '/admin/master-asset': 'Asset List',
  '/admin/master-asset-registration': 'Asset Registration',
  '/admin/booking': 'Booking',
  '/admin/maintenance': 'Maintenance',
  '/admin/remainder-list/': 'Remainder',  
  '/admin/request': 'Request',

  // == Data Master (third party)
  '/data-master': 'Data Master',
  '/data-master/location': 'Location',
  '/data-master/location/location': 'Location List',
  '/data-master/location/site': 'Location Site List',
  '/data-master/location/coverage': 'Coverage List',
  '/data-master/master': 'Master',
  '/data-master/master/asset-status': 'Asset Status List',
  '/data-master/master/asset-type': 'Asset Type List',
  '/data-master/master/business-model': 'Business Model List',
  '/data-master/master/contact': 'Contact List',
  '/data-master/master/contractor': 'Contractor List',
  '/data-master/master/departement': 'Departement List',
  '/data-master/master/site-status': 'Site Status List',
  '/data-master/master/site-type': 'Site Type List',
  '/data-master/master/maintenance-type': 'Maintenance Type List',
  '/data-master/user': 'User',
  '/data-master/user/role': 'Role List',
  '/data-master/user/user': 'User List',
  '/data-master/import' : 'Import List',

  // Superuser
  '/su': 'Superuser',
  '/su/create-tenant': 'Create Tenant',
  '/su/tenant-list': 'Tenant List',

  //QRReader
  '/qrreader' : 'QR Reader',

};
export default routes; 



// WEBPACK FOOTER //
// ./src/App/routes.js